module.exports = __webpack_public_path__ + "static/media/537JamesPBrawleyDrNW_2018-06-12_96.647179d1.jpg";